import $ from 'jquery';

(function (Drupal, once, $) {
  Drupal.behaviors.uaEuCookie = {
    attach: function (context) {
      // Add timeout to let DOM load cookie
      setTimeout(() => {
        // "Endast nödvändiga" => uncheck all non-required categories, then save preferences.
        const savePrefsBtn = $('.eu-cookie-compliance-save-preferences-button', context);
        const categoryCheckboxes = $('.eu-cookie-compliance-category-checkbox', context);

        once(
          'uaEuCookieEssential',
          '[data-cookie-consent-action="essential_only"]',
          context,
        ).forEach((el) => {
          $(el).on('click', function () {
            categoryCheckboxes.each(function () {
              const $cb = $(this);
              if (!$cb.is(':disabled')) {
                $cb.prop('checked', false);
              }
            });

            if (savePrefsBtn.length) {
              savePrefsBtn.first().trigger('click');
            }
          });
        });
      }, 200);
    },
  };
})(Drupal, once, jQuery);
